import React from 'react';

const Preloader = () => {
    return (
        <div className="global-preloader">
            <div className="preloader-content">
                <div className="spinner-chase">
                    <div className="chase-dot"></div>
                    <div className="chase-dot"></div>
                    <div className="chase-dot"></div>
                    <div className="chase-dot"></div>
                    <div className="chase-dot"></div>
                    <div className="chase-dot"></div>
                </div>
                <h5 className="mt-4 fw-semibold text-primary">Loading...</h5>
            </div>
        </div>
    );
};

export default Preloader;
